module.exports = __webpack_public_path__ + "static/media/paint.29c239dd.svg";